import { render, staticRenderFns } from "./project-center.vue?vue&type=template&id=712c7112&scoped=true"
import script from "./project-center.vue?vue&type=script&lang=js"
export * from "./project-center.vue?vue&type=script&lang=js"
import style0 from "./project-center.vue?vue&type=style&index=0&id=712c7112&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712c7112",
  null
  
)

export default component.exports